import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_NOTIFICATION_FETCH_BADGE,
  STORE_STATUS_INITIALIZED,
  STORE_NOTIFICATION,
} from 'constants/store'
import { ErrorStore, NotificationBadge } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type NotificationState = NotificationBadge

type State = GenericState<NotificationState>

export const initialState: State = {
  data: {
    buyer: {
      invoices: 0,
    },
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

// @deprecated - Buyer badge notification for invoices
export const fetchList = createAsyncThunk<
  NotificationState,
  Promise<NotificationBadge>,
  Payload
>(
  STORE_NOTIFICATION_FETCH_BADGE,
  async (promise: Promise<NotificationBadge>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  NotificationState,
  NotificationBadge,
  Payload
>(fetchList, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_NOTIFICATION,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear } = actions

export { clear }

export default reducer
